<template>
  <div class="equityvip">
    <div class="centerr">
      <div class="font_bo olione">
        <p>获取个性化和高性价比的联盟营销服务</p>
        <p>解锁AI联盟营销云平台专属功能</p>
      </div>
      <!-- <div class="sz18 mb30">
        <p>您可以选择符合公司业务的套餐，也可以与我们联系为您量身定制。</p>
      </div> -->
      <!-- <div class="buybtn" @click="gologin">免费体验</div> -->

      <div class="top_img">
        <img src="@/assets/img/home/vip.png" alt="" />
      </div>
    </div>
    <div v-if="false" class="viplist flex">
      <div class="listindex flex" v-for="(item, index) in viplist" :key="index">
        <div class="w100 mb10 listitone">
          <div class="sz20 font_bo">{{ item.mealNameZh }}</div>
          <div class="sz14">{{ item.mealNameEn }}</div>
        </div>
        <div class="w100 baff listitem">
          <div class="amount mb30">
            <span class="sz12 s1">¥</span>
            <span class="sz30 font_bo dib mr5">
              <span v-if="item.mealNameZh == '企业定制化'">联系客服</span>
              <v-countup
                v-else
                class="sz30 font_bo"
                duration="2"
                :start-value="item.oldPrice"
                :end-value="item.price"
              ></v-countup>
            </span>
            <span style="" class="sz12">
              <span v-if="item.mealNameZh != '企业定制化'">/ </span>
              <span v-if="item.mealNameZh == '免费试用'">{{
                item.monthNumber
              }}</span>
              {{ item.mealAddFormmat
              }}<span
                v-if="
                  item.mealNameZh != '企业定制化' &&
                  item.mealNameZh != '免费试用'
                "
                >度</span
              >
              <span v-if="item.mealNameZh == '免费试用'"></span>
            </span>
            <p class="sz12" v-if="item.oldPrice && avtivets != 1">
              原价:<span class="jg">¥{{ item.oldPrice }}</span>
            </p>
          </div>
          <div v-for="(itm, index1) in item.mealDesc" :key="index1">
            <div class="w100 mb20 flex liestms">
              <div class="correct ru50"></div>
              <div class="sz12">{{ itm }}</div>
            </div>
          </div>
          <div class="submit">
            <div class="cev cursor flex" @click="submits(item)">
              <!-- <img v-if="item.mealNameZh == '免费试用'" src="@/assets/img/home/hz.png" alt=""> -->
              立即订阅
            </div>
          </div>
          <div class="tri4 coff" v-if="item.economizeDesc"></div>
          <div class="economize" v-if="item.economizeDesc">
            <p class="economize_img fs12 flex coff mb10">
              <img src="@/assets/img/home/bz.png" alt="" /> 节省
            </p>
            <p class="coff economize_img fs12">¥ {{ item.economizeDesc }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="newvipmain">
      <div>
        <el-tabs v-model="choosedTabValue" type="card">
          <el-tab-pane
            style="color: #be3c6e"
            label="平台功能"
            name="tab1"
          ></el-tab-pane>
          <el-tab-pane label="定制服务" name="tab2"></el-tab-pane>
        </el-tabs>
      </div>
      <div v-show="choosedTabValue === 'tab1'" class="newviplist flex">
        <div class="top">
          <div class="ptbox">
            <div class="left">
              <div class="content">
                <div
                  :class="packageType === 'A' ? 'Package actived' : 'Package'"
                  @click="choosePackageType('A')"
                >
                  <div class="horntips"></div>
                  <div class="horntipsText">企业版A</div>
                  情报洞察 + 联盟交易
                  <!-- 企业版A -->
                </div>
                <div
                  :class="packageType === 'B' ? 'Package actived' : 'Package'"
                  @click="choosePackageType('B')"
                >
                  <div class="horntips"></div>
                  <div class="horntipsText">企业版B</div>
                  联盟交易 + 多平台管理
                  <!-- 企业版B -->
                </div>
                <div
                  :class="packageType === 'C' ? 'Package actived' : 'Package'"
                  @click="choosePackageType('C')"
                >
                  <div class="horntips"></div>
                  <div class="horntipsText">旗舰版</div>
                  情报洞察 + 联盟交易 + 多平台管理
                  <!-- 旗舰版 -->
                </div>
              </div>
            </div>
            <div class="right">
              <div class="contentText">
                <div
                  class="item"
                  v-if="packageType === 'A' || packageType === 'C'"
                >
                  <p class="itemtitle">
                    <i class="el-icon-star-on"></i>情报洞察
                  </p>
                  <p class="itemdesc">
                    一键洞察全球18个行业和100万+品牌的联盟分销策略
                  </p>
                  <p class="itemdesc">
                    核心算法智能分析1000万+联盟伙伴分销数据并精准触达
                  </p>
                </div>
                <div class="item">
                  <p class="itemtitle">
                    <i class="el-icon-star-on"></i>联盟交易(限时赠送)
                  </p>
                  <p class="itemdesc">
                    一键发布独立站和三方电商平台的联盟营销任务
                  </p>
                  <p class="itemdesc">智能推荐与精准匹配高转化联盟伙伴</p>
                  <p class="itemdesc">品牌+经营双增长</p>
                </div>
                <div
                  class="item"
                  v-if="packageType === 'B' || packageType === 'C'"
                >
                  <p class="itemtitle">
                    <i class="el-icon-star-on"></i>多平台管理
                  </p>
                  <p class="itemdesc">一键授权接入多个联盟平台</p>
                  <p class="itemdesc">自动识别作弊重复订单规避佣金损失</p>
                  <p class="itemdesc">一站式管理全渠道数据</p>
                </div>
              </div>
            </div>
            <div class="center">
              <div class="contentText">
                <p>
                  <i class="el-icon-success"></i>可同时登录{{
                    1 + addedForm.num1
                  }}台设备
                </p>
                <p v-if="packageType != 'B'">
                  <i class="el-icon-success"></i
                  >{{ 1 + addedForm.num2 }}个行业的全球联盟营销情报洞察
                </p>
                <p v-if="packageType != 'B'">
                  <i class="el-icon-success"></i
                  >{{ 3 + addedForm.num3 }}个品牌的全球联盟分销情况
                </p>
                <p>
                  <i class="el-icon-success"></i>AFF Copilot互动{{
                    paymentType == "A"
                      ? 120 + addedForm.num5
                      : paymentType == "B"
                      ? 240 + addedForm.num5
                      : 480 + addedForm.num5
                  }}次/{{ showTypeTitle }}
                </p>
                <p v-if="packageType != 'B'">
                  <i class="el-icon-success"></i
                  >{{
                    paymentType == "A"
                      ? 1000 + addedForm.num4
                      : paymentType == "B"
                      ? 2000 + addedForm.num4
                      : 4000 + addedForm.num4
                  }}封/{{ showTypeTitle }}的联盟客沟通邮件
                  <el-tooltip
                    class="item"
                    effect="dark"
                    placement="right"
                    content="针对情报洞察模块"
                  >
                    <i style="color: #adadad" class="el-icon-info"></i>
                  </el-tooltip>
                </p>
                <p>
                  <i class="el-icon-success"></i
                  >{{ 1 + addedForm.num7 }}个亚马逊广告账号授权
                </p>
                <p>
                  <i class="el-icon-success"></i
                  >{{ 1 + addedForm.num8 }}个独立站授权
                </p>
                <p><i class="el-icon-success"></i>技术对接及联调服务</p>
                <p><i class="el-icon-success"></i>5*8在线工程师运维服务</p>
                <p style="color: #be3c6e">
                  <i class="el-icon-success" style="color: #be3c6e"></i
                  >限时减免开户手续费(价值3570元)
                </p>
                <p style="color: #be3c6e">
                  <i class="el-icon-success" style="color: #be3c6e"></i
                  >限时减免技术服务费（价值3570元）
                </p>
              </div>
            </div>
          </div>
          <div class="centerbox">
            <el-collapse v-model="activeNames">
              <el-collapse-item title="平台增量包" name="1">
                <div class="addcontent">
                  <div class="left"></div>
                  <div class="right"></div>
                  <el-row>
                    <el-form label-position="left" :model="addedForm">
                      <el-col :span="12">
                        <el-form-item label="同时登录设备数(台)">
                          <el-input-number
                            v-model="addedForm.num1"
                            @change="handleChange(2)"
                            :min="0"
                            :max="99999"
                            :step="1"
                            step-strictly
                          ></el-input-number>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :span="12"
                        v-if="packageType === 'A' || packageType === 'C'"
                      >
                        <el-form-item label="情报洞察行业数(个)">
                          <el-input-number
                            v-model="addedForm.num2"
                            @change="handleChange(3)"
                            :min="0"
                            :max="99999"
                            :step="1"
                            step-strictly
                          ></el-input-number>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :span="12"
                        v-if="packageType === 'A' || packageType === 'C'"
                      >
                        <el-form-item label="情报洞察品牌数(个)">
                          <el-input-number
                            v-model="addedForm.num3"
                            @change="handleChange(4)"
                            :min="0"
                            :max="99999"
                            :step="3"
                            step-strictly
                          ></el-input-number>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :span="12"
                        v-if="packageType === 'A' || packageType === 'C'"
                      >
                        <el-form-item label="联盟客沟通邮件数(封)">
                          <el-input-number
                            v-model="addedForm.num4"
                            @change="handleChange(5)"
                            :min="0"
                            :max="99999"
                            :step="1000"
                            step-strictly
                          ></el-input-number>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="AFF Copilot 互动数(次)">
                          <el-input-number
                            v-model="addedForm.num5"
                            @change="handleChange(6)"
                            :min="0"
                            :max="99999"
                            :step="100"
                            step-strictly
                          ></el-input-number>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="赋能运营服务(月)">
                          <el-input-number
                            v-model="addedForm.num6"
                            @change="handleChange(6)"
                            :min="0"
                            :max="12"
                            :step="6"
                            step-strictly
                          ></el-input-number>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="亚马逊广告账号授权(个)">
                          <el-input-number
                            v-model="addedForm.num7"
                            @change="handleChange(2)"
                            :min="0"
                            :max="99999"
                            :step="1"
                            step-strictly
                          ></el-input-number>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="独立站(个)">
                          <el-input-number
                            v-model="addedForm.num8"
                            @change="handleChange(2)"
                            :min="0"
                            :max="99999"
                            :step="1"
                            step-strictly
                          ></el-input-number>
                        </el-form-item>
                      </el-col>
                    </el-form>
                  </el-row>
                </div>
              </el-collapse-item>
            </el-collapse>
            <div class="pricebox">
              <div class="paycontent">
                <div class="paytype">
                  <div class="flex">
                    <div class="butt flex">
                      <div
                        class="butt_list ml cursor center"
                        :class="paymentType === 'A' ? 'buttna' : ''"
                        @click="payTypeclick('A')"
                      >
                        季度
                        <div
                          style="font-size: 12px; border-radius: 50%"
                          class="ml_tips ru50 coff ba6e"
                        >
                          -10%
                        </div>
                      </div>
                      <div
                        class="butt_list ml cursor center"
                        :class="paymentType === 'B' ? 'buttna' : ''"
                        @click="payTypeclick('B')"
                      >
                        半年
                        <div
                          style="font-size: 12px; border-radius: 50%"
                          class="ml_tips ru50 coff ba6e"
                        >
                          -15%
                        </div>
                      </div>
                      <div
                        class="butt_list ml cursor center"
                        :class="paymentType === 'C' ? 'buttna' : ''"
                        @click="payTypeclick('C')"
                      >
                        年度
                        <div
                          style="font-size: 12px; border-radius: 50%"
                          class="ml_tips ru50 coff ba6e"
                        >
                          -25%
                        </div>
                      </div>
                    </div>
                    <div class="butt_img">
                      <img src="@/assets/img/home/xn.png" alt="" />
                    </div>
                  </div>
                </div>
                <div class="pricenum cleanfix">
                  <div class="box">
                    <span class="danwei"></span>
                    <span class="danwei"></span>
                    <span class="now">¥{{ beforePrice }}</span>
                    <span class="before">/</span>
                    <span class="before">{{ showTypeTitle }}原价</span>
                    <span class="danwei">&nbsp;&nbsp;-</span>
                    <span class="danwei">&nbsp;&nbsp;</span>
                    <span class="now specil"
                      >¥{{ beforePrice - nowPrice }}</span
                    >
                    <span class="before">/</span>
                    <span class="before">{{ showTypeTitle }}优惠</span>
                    <span class="danwei"></span>
                    <span class="danwei">&nbsp;&nbsp;=</span>
                    <span class="danwei">&nbsp;&nbsp;</span>
                    <span class="danwei"></span>
                    <span class="now">¥{{ nowPrice }}</span>
                    <span class="before">/</span>
                    <span class="before bold">{{ showTypeTitle }}现价</span>
                    <span class="buybtn" @click="goBuy">立即购买</span>
                  </div>
                  <!-- <div> 
                    <span class="danwei">¥</span>
                    <span class="now">{{ nowPrice }}</span>
                    <span class="before">/</span>
                    <span class="before">{{ beforePrice }}</span>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="choosedTabValue === 'tab2'" class="newviplist flex">
        <div class="dzfwleft">
          <div class="contentText">
            <div class="item">
              <p class="itemtitle">
                <i class="el-icon-star-on"></i>联盟营销联合运营服务
              </p>
              <p>专属运营服务团队，助力品牌与经营双增长</p>
            </div>
            <div class="item">
              <p class="itemtitle">
                <i class="el-icon-star-on"></i>AI Spark 多样化营销素材智能生成
              </p>
            </div>
            <div class="item">
              <p class="itemtitle">
                <i class="el-icon-star-on"></i>海外本地资源合作、媒介策略与采买
              </p>
              <p>全球头部媒体</p>
              <p>垂类及小语种媒体</p>
              <p>KOL红人资源</p>
              <p>线下OOH户外</p>
              <p>电视媒体及娱乐营销合作</p>
            </div>
          </div>
        </div>
        <div class="dzfwright">
          <div class="contentText">
            <div class="nologins_title">
              <div class="nologins_title_img">
                <img
                  style="width: 100%"
                  src="@/assets/img/home/kf2.png"
                  alt=""
                />
              </div>
              <div class="nologins_title_text center">
                咨询微信客服，购买套餐
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { COOPERATEBRANDLOGOS, SETMEALS } from "../../api/payment";
export default {
  data() {
    return {
      liststuts: false,
      avtivets: 2,
      mealType: "QUARTER",
      viplist: [],
      url: process.env.VUE_APP_BASE_API,
      activeName: "4",

      defaultOption: {
        direction: 2,
        step: 1,
        limitMoveNum: 3,
      },
      list: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],

      // 套餐
      packageType: "A",
      paymentType: "A",
      addedForm: {
        num1: 0,
        num2: 0,
        num3: 0,
        num4: 0,
        num5: 0,
        num6: 0,
        num7: 0,
        num8: 0,
      },
      activeNames: ["1"],
      choosedTabValue: "tab1",
      // 价格表
      pricePackageNow: {
        seasonA: 13888,
        halfyearA: 21999,
        yearA: 27999,
        seasonB: 13888,
        halfyearB: 21999,
        yearB: 27999,
        seasonC: 18888,
        halfyearC: 29999,
        yearC: 36999,
      },
      pricePackageBefore: {
        seasonA: 13888,
        halfyearA: 25888,
        yearA: 42888,
        seasonB: 13888,
        halfyearB: 25888,
        yearB: 42888,
        seasonC: 18888,
        halfyearC: 35188,
        yearC: 56999,
      },
      priceAddNow: {
        //现在的增量包价格
        dlsbnum: 999,
        hynum: 999,
        ppnum: 360,
        emailnum: 360,
        copilotnum: 360,
        amazonNum: 720,
        inStationNum: 720,
        sevicePrice: 9999,
      },
    };
  },
  filters: {
    showTypeTitle(val) {
      if (val === "A") {
        return "季度";
      } else if (val === "B") {
        return "半年";
      } else {
        return "年度";
      }
    },
  },
  computed: {
    nowPrice() {
      let pricePackage = 0;
      let priceTotal = 0;

      let pricefnyyfw = 0;

      let pricedlsbTotal = 0;
      let pricehyTotal = 0;
      let priceppTotal = 0;
      let priceemailTotal = 0;
      let pricecopilotTotal = 0;
      let priceAmazonTotal = 0;
      let priceInStationTotal = 0;
      let addpriceTotal = 0;

      pricedlsbTotal = this.priceAddNow.dlsbnum * this.addedForm.num1;
      pricehyTotal = this.priceAddNow.hynum * this.addedForm.num2;
      priceppTotal = this.priceAddNow.ppnum * (this.addedForm.num3 / 3);
      priceemailTotal =
        this.priceAddNow.emailnum * (this.addedForm.num4 / 1000);
      pricecopilotTotal =
        this.priceAddNow.copilotnum * (this.addedForm.num5 / 100);
      priceAmazonTotal = this.priceAddNow.amazonNum * this.addedForm.num7;
      priceInStationTotal = this.priceAddNow.inStationNum * this.addedForm.num8;
      addpriceTotal =
        pricedlsbTotal +
        pricehyTotal +
        priceppTotal +
        priceemailTotal +
        pricecopilotTotal +
        priceAmazonTotal +
        priceInStationTotal;
      pricefnyyfw = this.priceAddNow.sevicePrice * this.addedForm.num6;

      if (this.packageType === "A" && this.paymentType === "A") {
        pricePackage = this.pricePackageNow.seasonA;
      }
      if (this.packageType === "A" && this.paymentType === "B") {
        pricePackage = this.pricePackageNow.halfyearA;
      }
      if (this.packageType === "A" && this.paymentType === "C") {
        pricePackage = this.pricePackageNow.yearA;
      }
      if (this.packageType === "B" && this.paymentType === "A") {
        pricePackage = this.pricePackageNow.seasonB;
      }
      if (this.packageType === "B" && this.paymentType === "B") {
        pricePackage = this.pricePackageNow.halfyearB;
      }
      if (this.packageType === "B" && this.paymentType === "C") {
        pricePackage = this.pricePackageNow.yearB;
      }
      if (this.packageType === "C" && this.paymentType === "A") {
        pricePackage = this.pricePackageNow.seasonC;
      }
      if (this.packageType === "C" && this.paymentType === "B") {
        pricePackage = this.pricePackageNow.halfyearC;
      }
      if (this.packageType === "C" && this.paymentType === "C") {
        pricePackage = this.pricePackageNow.yearC;
      }
      priceTotal = pricePackage + pricefnyyfw + addpriceTotal;
      return Math.trunc(priceTotal);
    },
    beforePrice() {
      let pricePackage = 0;
      let priceTotal = 0;

      let pricefnyyfw = 0;

      let pricedlsbTotal = 0;
      let pricehyTotal = 0;
      let priceppTotal = 0;
      let priceemailTotal = 0;
      let pricecopilotTotal = 0;
      let priceAmazonTotal = 0;
      let priceInStationTotal = 0;
      let addpriceTotal = 0;

      pricedlsbTotal = this.priceAddNow.dlsbnum * this.addedForm.num1;
      pricehyTotal = this.priceAddNow.hynum * this.addedForm.num2;
      priceppTotal = this.priceAddNow.ppnum * (this.addedForm.num3 / 3);
      priceemailTotal =
        this.priceAddNow.emailnum * (this.addedForm.num4 / 1000);
      pricecopilotTotal =
        this.priceAddNow.copilotnum * (this.addedForm.num5 / 100);
      priceAmazonTotal = this.priceAddNow.amazonNum * this.addedForm.num7;
      priceInStationTotal = this.priceAddNow.inStationNum * this.addedForm.num8;
      addpriceTotal =
        pricedlsbTotal +
        pricehyTotal +
        priceppTotal +
        priceemailTotal +
        pricecopilotTotal +
        priceAmazonTotal +
        priceInStationTotal;
      pricefnyyfw = this.priceAddNow.sevicePrice * this.addedForm.num6;

      if (this.packageType === "A" && this.paymentType === "A") {
        pricePackage = this.pricePackageBefore.seasonA;
      }
      if (this.packageType === "A" && this.paymentType === "B") {
        pricePackage = this.pricePackageBefore.halfyearA;
      }
      if (this.packageType === "A" && this.paymentType === "C") {
        pricePackage = this.pricePackageBefore.yearA;
      }
      if (this.packageType === "B" && this.paymentType === "A") {
        pricePackage = this.pricePackageBefore.seasonB;
      }
      if (this.packageType === "B" && this.paymentType === "B") {
        pricePackage = this.pricePackageBefore.halfyearB;
      }
      if (this.packageType === "B" && this.paymentType === "C") {
        pricePackage = this.pricePackageBefore.yearB;
      }
      if (this.packageType === "C" && this.paymentType === "A") {
        pricePackage = this.pricePackageBefore.seasonC;
      }
      if (this.packageType === "C" && this.paymentType === "B") {
        pricePackage = this.pricePackageBefore.halfyearC;
      }
      if (this.packageType === "C" && this.paymentType === "C") {
        pricePackage = this.pricePackageBefore.yearC;
      }
      priceTotal = pricePackage + pricefnyyfw + addpriceTotal;
      return Math.trunc(priceTotal);
    },
    showTypeTitle() {
      let result = "";
      if (this.paymentType === "A") {
        result = "季度";
      } else if (this.paymentType === "B") {
        result = "半年";
      } else {
        result = "年度";
      }
      return result;
    },
  },
  mounted() {},
  methods: {
    payTypeclick(e) {
      this.paymentType = e;
    },
    handleChange(val) {
      console.log(val);
    },
    choosePackageType(val) {
      this.packageType = val;
      this.addedForm = {
        num1: 0,
        num2: 0,
        num3: 0,
        num4: 0,
        num5: 0,
        num6: 0,
        num7: 0,
        num8: 0,
      };
    },
    payTypeclick(e) {
      this.paymentType = e;
    },
    handleChange(val) {
      console.log(val);
    },
    goBuy() {
      this.$bus.$emit("showAiSpark", true);
    },
    gologin() {
      if (this.url == "/dev") {
        window.open("https://www.foshoaff.com");
      } else if (this.url == "/prod") {
        window.open("https://www.foshoaff.com");
      } else if (this.url == "/test") {
        window.open("https://sit-aff.foshobrands.com");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.equityvip {
  width: 100%;
  min-width: 970px !important;

  .viewtop {
    margin-bottom: 110px;
  }

  .centerr {
    width: 100%;
    margin: 0 auto;
    position: relative;

    .olione {
      font-size: 40px;
    }

    .top_img {
      position: absolute;
      right: 0;
      top: -20px;

      img {
        width: 455px;
      }
    }

    .butt {
      height: 37px;
      width: 340px;
      border-radius: 30px;
      box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.16);

      .butt_list {
        width: 120px;
        height: 100%;
        border-radius: 30px;
        line-height: 37px;
      }

      .ml {
        margin-left: -10px;
        position: relative;

        .ml_tips {
          width: 42px;
          height: 42px;
          line-height: 42px;
          position: absolute;
          top: -60%;
          right: 10px;
        }
      }

      .buttna {
        background: #000;
        color: #fff;
      }
    }

    .butt_img {
      margin-left: 20px;
      margin-top: -30px;
      opacity: 0;

      img {
        height: 75px;
      }
    }
  }

  .viplist {
    width: 85%;
    margin: 0 auto;
    justify-content: space-between;
    margin-top: 30px;

    .listindex {
      min-height: 530px;
      width: 23%;
      flex-direction: column;

      .listitone {
        height: 90px;
        max-height: 50px !important;
        width: 100%;
      }

      .listitem {
        box-sizing: border-box;
        width: 100%;
        min-height: 250px !important;
        flex: 1;
        padding: 20px 15px 20px 30px;
        position: relative;

        .amount {
          position: relative;

          .s1 {
            position: absolute;
            left: -15px;
            top: 0;
          }

          .jg {
            text-decoration: line-through;
          }
        }

        .liestms {
          // height: 20px;
          align-items: center;
        }

        .correct {
          width: 14px;
          height: 14px;
          line-height: 20px;
          border: 1px solid #000;
          background-color: #000;
          position: relative;
          cursor: pointer;
          margin-right: 10px;
          margin-top: -2px;
        }

        .correct::before {
          position: absolute;
          content: " ";
          width: 4px;
          height: 8px;
          transform: rotate(45deg);
          border-right: 2px solid #fff;
          border-bottom: 2px solid #fff;
          top: 1px;
          left: 4px;
        }

        .submit {
          width: 100%;
          height: 40px;
          position: absolute;
          bottom: 20px;
          left: 0;

          .cev {
            width: 95%;
            height: 100%;
            margin: 0 auto;
            background: #f4f5f9;
            justify-content: center;
            align-items: center;

            img {
              width: 16px;
              margin-right: 5px;
            }
          }
        }

        .tri4 {
          width: 0;
          height: 0;
          border-color: #be3c6e transparent;
          /*上下颜色 左右颜色*/
          border-width: 146px 0 0 146px;
          border-style: solid;
          position: absolute;
          top: 0;
          right: 0;
        }

        .economize {
          width: 146px;
          position: absolute;
          top: 10px;
          right: 0;
          text-align: right;

          .economize_img {
            height: 18px;
            align-items: center;
            justify-content: flex-end;
            padding-right: 5px;

            img {
              width: 18px;
              margin-right: 10px;
            }
          }
        }
      }

      // .listitem:hover {
      //   transform: scale(1.1);
      // }
    }

    .listindex:hover {
      transform: scale(1.05);
    }
  }

  .newvipmain {
    width: 100%;
    margin: 0 auto;
    background-color: #ffffff;
    border-radius: 8px;
    margin-top: 50px;
  }

  .newviplist {
    width: 100%;
    justify-content: space-between;

    .top {
      width: 100%;
    }

    .title {
      width: 100%;
      height: 50px;
      line-height: 50px;
      font-size: 24px;
      color: #000;
      text-align: center;
      padding: 10px 0;
      border-bottom: 1px solid #fff;
    }

    .ptbox {
      width: 100%;
      display: flex;
      border-bottom: 1px solid #fff;

      .left {
        width: 34%;
        border-right: 1px solid #ebeef5;
      }

      .center {
        width: 33%;

        padding: 15px;
        position: relative;

        .contentText {
          width: 90%;
          line-height: 50px;
          text-align: left;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          p {
            font-size: 20px;
            padding-left: 5px;
          }

          i {
            margin-right: 10px;
          }
        }
      }

      .right {
        width: 35%;
        position: relative;
        padding: 15px;
        border-right: 1px solid #ebeef5;

        .contentText {
          width: 90%;
          text-align: center;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          .item {
            margin-bottom: 20px;
            line-height: 30px;

            .itemtitle {
              font-size: 24px;
              line-height: 45px;
              font-weight: 600;
            }

            .itemdesc {
              font-size: 22px;
            }

            i {
              margin-right: 10px;
            }
          }
        }
      }

      .content {
        padding-top: 35px;
        box-sizing: border-box;

        .Package {
          box-sizing: border-box;
          width: 90%;
          margin: auto;
          height: 120px;
          text-align: center;
          line-height: 120px;
          background-color: #fff;
          border-radius: 8px;
          margin-bottom: 35px;
          position: relative;
          box-sizing: border-box;
          overflow: hidden;
          font-size: 18px;
          box-shadow: none;
          font-weight: 600;
          cursor: pointer;
          border: 1px solid #be3c6e;

          &:hover {
            border: 5px solid #be3c6e;
          }

          &.actived {
            border: 5px solid #be3c6e;
          }

          .horntips {
            box-sizing: border-box;
            width: 0;
            height: 0;
            border-color: #be3c6e transparent;
            border-width: 90px 0 0 120px;
            border-style: solid;
            position: absolute;
            top: 0;
            right: 0;
          }

          .horntipsText {
            width: 120px;
            height: 120px;
            position: absolute;
            top: -25px;
            right: -22px;
            color: #fff;
            font-weight: 500;
            transform: rotateZ(37deg);
            font-size: 18px;
          }
        }
      }
    }

    .centerbox {
      width: 100%;
      // background-color: green;

      .title {
        width: 100%;
        height: 50px;
        line-height: 50px;
        font-size: 24px;
        color: #000;
        text-align: center;
        padding: 10px 0;
        border-bottom: 1px solid #fff;
      }

      .addcontent {
        padding: 20px 0 0 150px;
        border-bottom: 1px solid #fff;
      }

      /deep/.el-collapse-item {
        padding: 0 35px;
      }

      .pricebox {
        .paycontent {
          display: flex;
          margin-top: 50px;
          margin-bottom: 50px;

          .paytype {
            width: 30%;
            padding-left: 35px;

            .butt {
              height: 37px;
              width: 340px;
              border-radius: 30px;
              box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.16);

              .butt_list {
                width: 120px;
                height: 100%;
                border-radius: 30px;
                line-height: 37px;
              }

              .ml {
                margin-left: -10px;
                position: relative;

                .ml_tips {
                  width: 42px;
                  height: 42px;
                  line-height: 42px;
                  position: absolute;
                  top: -60%;
                  right: 10px;
                }
              }

              .buttna {
                background: #000;
                color: #fff;
              }
            }

            .butt_img {
              margin-left: 20px;
              margin-top: -30px;

              img {
                height: 75px;
              }
            }
          }

          .pricenum {
            width: 70%;
            padding-right: 35px;
            font-size: 38px;
            font-weight: 600;
            text-align: right;

            .box {
              .specil {
                color: #be3c6e;
              }

              .buybtn {
                display: inline-block;
                padding: 10px 20px;
                background-color: #be3c6e;
                font-size: 20px;
                border-radius: 8px;
                margin-left: 15px;
                color: #fff;
                transform: translateY(-8px);
                cursor: pointer;
              }
            }

            .before {
              font-size: 18px;
              // text-decoration: line-through;
            }
          }
        }
      }
    }

    .dzfwleft {
      width: 50%;
      // border-right: 1px solid #EBEEF5;
      padding: 50px 10px 50px 10px;

      .contentText {
        width: 90%;
        text-align: center;

        .item {
          margin-bottom: 20px;
          line-height: 30px;
          font-size: 18px;

          .itemtitle {
            font-size: 22px;
            line-height: 30px;
            font-weight: 600;
          }

          i {
            margin-right: 10px;
          }
        }
      }
    }

    .dzfwright {
      width: 50%;
      padding: 50px 10px 50px 10px;

      .contentText {
        width: 30%;
        text-align: center;
        margin: 0 auto;

        .nologins_title_text {
          font-size: 20px;
        }
      }
    }
  }

  .introduce {
    width: 85%;
    margin: 0 auto;

    .introduce_list {
      border-bottom: 1px solid #a6a8bf;
      padding-bottom: 20px;

      i {
        float: right;
      }

      p {
        font-weight: 400;
      }
    }
  }

  .contact {
    color: #5a8cff;
  }
}

.nologins {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5, #000);
  z-index: 1;

  .nologins_title {
    width: 400px;
    height: 400px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -200px;
    margin-left: -200px;
    background: #fff;
    border-radius: 15px;
    padding: 20px;
  }

  .nologins_title_icon {
    width: 100%;
    text-align: right;
    font-size: 26px;
    padding-right: 10px;

    i {
      color: #000;
    }
  }

  .nologins_title_img {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    margin-top: 40px;

    img {
      width: 200px;
      height: 200px;
      display: inline-block;
      margin: 0 auto;
    }
  }

  .nologins_title_text {
    width: 100%;
    margin-top: 50px;
    font-size: 22px;
  }
}

@media screen and (min-width: 300px) and (max-width: 1000px) {
  .listindex {
    // height: 560px;

    .listitone {
      height: 90px;
      min-height: 50px !important;
      max-height: 50px !important;
      width: 100%;
    }

    .listitem {
      box-sizing: border-box;
      width: 100%;
      min-height: 180px !important;
      flex: 1;
      padding: 20px 15px 20px 30px;
      position: relative;
    }

    .tri4 {
      width: 0;
      height: 0;
      border-color: #be3c6e transparent;
      /*上下颜色 左右颜色*/
      border-width: 136px 0 0 136px;
      border-style: solid;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}

@media screen and (min-width: 1000px) and (max-width: 2000px) {
  .listindex {
    // height: 560px;

    .listitem {
      min-height: 300px !important;
    }

    .economize {
      .economize_img {
        font-size: 16px !important;
        height: 18px;
        align-items: center;
        justify-content: flex-end;
        padding-right: 5px;

        img {
          width: 17px !important;
        }
      }
    }
  }
}

@media screen and (min-width: 2000px) and (max-width: 3000px) {
  .listindex {
    // height: 630px;

    .economize {
      .economize_img {
        font-size: 18px !important;
        height: 18px;
        align-items: center;
        justify-content: flex-end;
        padding-right: 5px;

        img {
          width: 19px !important;
        }
      }
    }
  }
}

/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #be3c6e !important;
  border-color: #be3c6e !important;
  -webkit-box-shadow: -0.0625rem 0 0 0 #be3c6e !important;
  box-shadow: -0.0625rem 0 0 0 #be3c6e !important;

  &:hover {
    color: #fff !important;
  }
}

/deep/.el-radio-button__inner {
  &:hover {
    color: #be3c6e !important;
  }
}

/deep/.el-form-item__label {
  width: 230px;
  min-width: 120px;
}

/deep/.el-tabs__item {
  height: 60px;
  line-height: 60px;
  font-size: 22px;
  font-weight: 600;
}

/deep/.el-tabs__item.is-active {
  color: #be3c6e;
}

/deep/.el-tabs__item:hover {
  color: #be3c6e;
  cursor: pointer;
}

/deep/.el-switch {
  transform: translateY(-2px);
}
</style>
<style lang="less">
.el-collapse-item__header {
  font-weight: bold;
  font-size: 18px;
  background: none;
  height: 90px;
}

.el-collapse-item__wrap {
  background: none;
  font-size: 16px;
  color: #000;
}

.el-icon-arrow-right:before {
  content: "\e791";
}
</style>
